import React from 'react'
import { useSelector } from 'react-redux'
import { Alert, AlertTitle } from '@mui/material'

import { AuthStates, getUserTokenState } from 'utils/authUtils'

const ForbiddenAccessAlert = ({ requriedScopes, screenName, children }) => {
  const token = useSelector((state) => state.auth.access_token)
  const isAuthorized = getUserTokenState(token, requriedScopes) === AuthStates.AUTHORIZED

  if (isAuthorized) return children

  return (
    <Alert severity="warning" style={{ width: '95%', boxSizing: 'border-box', margin: '0 auto' }}>
      <AlertTitle>Conteúdo restrito</AlertTitle>
      Você não tem permissão para visualizar a {screenName}
    </Alert>
  )
}

export default ForbiddenAccessAlert
